// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__QovdK","header":"Messages_header__NPAS9"};